module.exports = __webpack_public_path__ + "img/screenshot_example_03.73237b11.png";